<template>
    <div class="partner-box" :class="{'partner-box--active': active}">
        <div class="partner-box-header" v-on:click="toggleActive">
            <div class="partner-logo" :class="{'partner-logo--no-logo': !hasLogo()}">
                <img v-if="hasLogo()" :src="partner.logo_url" :alt="partner.title" loading="lazy">
            </div>
            <div class="partner-title">{{partner.title}}</div>
            <div class="partner-collapse-handle">
                <arrow-icon></arrow-icon>
            </div>
        </div>
        <div class="partner-box-body">
            <div class="partner-description" v-if="hasDescription()" v-html="partner.description"></div>
            <div class="partner-attributes">
                <div class="partner-attribute partner-address" v-if="hasAddress()">
                    <span class="attribute-label">
                        <pin-icon></pin-icon>
                        Adresse
                    </span>
                    {{partner.zip}} {{partner.city}}, {{partner.street}}
                </div>
                <div class="partner-attribute partner-website" v-if="hasWebsite()">
                    <a class="attribute-label" :href="partner.website" target="_blank" rel="noopener">
                        <link-icon></link-icon>
                        Webseite
                    </a>
                </div>
                <div class="partner-attribute partner-category" v-if="hasCategory()">
                    <span class="attribute-label">
                        <category-icon></category-icon>
                        Kategorie
                    </span>
                    {{partner.category}}
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ArrowIcon from "./ArrowIcon";
import PinIcon from "./PinIcon";
import LinkIcon from "./LinkIcon";
import CategoryIcon from "./CategoryIcon";
export default {
    name: "PartnerBox",
    components: {CategoryIcon, LinkIcon, PinIcon, ArrowIcon},
    props: ['partner'],

    data() {
        return {
            active: false
        }
    },

    methods: {
        hasLogo() {
            return !!this.partner.logo
                && !!this.partner.logo_url;
        },

        hasDescription() {
            return !!this.partner.description;
        },

        hasAddress() {
            return !!this.partner.zip
                && !!this.partner.city
                && !!this.partner.street;
        },

        hasWebsite() {
            return !!this.partner.website;
        },

        hasCategory() {
            return !!this.partner.category;
        },

        toggleActive() {
            this.active = !this.active;
        }
    }
}
</script>
